import { useNavigate } from 'react-router-dom';
import { IItemObj } from 'api/types/marketplace';

// Static Assets
// import CardPicture from '../../../assets/images/croc.png';
import ItemFrame from '../../../assets/images/frames/item_frame@2x.png';
import ItemFrameInactive from '../../../assets/images/frames/item_frame_inactive@2x.png';
import ItemFrameBlank from '../../../assets/images/frames/item_frame_blank@2x.png';
import ItemFrameBlankInactive from '../../../assets/images/frames/item_frame_blank_inactive@2x.png';
import EtheriumIcon from '../../../assets/images/icons/eth@2x.png';
// import PaperIcon from '../../../assets/images/icons/paper@2x.png';
import PaperOutline from '../../../assets/images/icons/paper_outline@2x.png';
import RoutesList from 'config/constants';
import { Fragment } from 'react';

interface Props {
  itemsList: Array<IItemObj>;
  totalRows: number;
}

const CardLists = ({ itemsList }: Props) => {
  const navigate = useNavigate();

  return (
    <>
      <section className="section-card">
        <div className="section-card-wrap">
          <div className="card-lists">
            {itemsList.length > 0 ? (
              itemsList.map((obj, key) => (
                <div
                  key={key}
                  className={`card-lists-item position-relative${obj.sellType === 'buy' ? `card-active` : ``} ${
                    obj.thumbImageUrl ? `card-active` : ``
                  }`}
                  onClick={() => navigate(`${RoutesList.ITEM_DETAIL_PAGE}?id=${obj.id}`)}
                  role="button"
                >
                  {obj.thumbImageUrl && (
                    <img src={obj.thumbImageUrl} alt={`${obj.title} card`} className="card-picture img-fluid" />
                  )}

                  {/* Initial Frame */}
                  <img
                    src={ItemFrameInactive}
                    alt={`${obj.title} frame card`}
                    className="card-frame-inactive img-fluid"
                  />

                  <img
                    src={ItemFrameBlankInactive}
                    alt={`${obj.title} frame card`}
                    className="card-frame-blank-inactive img-fluid"
                  />

                  {/* Hover Frame */}
                  <img
                    src={obj.thumbImageUrl ? ItemFrameBlank : ItemFrame}
                    alt={`${obj.title} frame card`}
                    className="card-frame card-frame-active img-fluid"
                  />

                  <div className="card-details">
                    <h3 className="card-title">{obj.title}</h3>
                    <div className="align-center">
                      {(obj.sellType === 'buy' || obj.sellType === 'raffle') && (
                        <Fragment>
                          {obj.buyPriceEth && obj.buyPriceEth > 0 && (
                            <div className="align-center mr-2">
                              <div className="icon-16">
                                <img src={EtheriumIcon} alt="Etherium" className="img-fluid" />
                              </div>
                              <p className="card-text text-white">{obj.buyPriceEth}</p>
                            </div>
                          )}
                          {obj.buyPricePaper && obj.buyPricePaper > 0 && (
                            <div className="align-center">
                              <div className="icon-16">
                                <img src={PaperOutline} alt="Paper Outline" className="img-fluid" />
                              </div>
                              <p className="card-text">
                                {obj.sellType === 'raffle' && !obj.isActive ? 'RAFFLE CLOSED' : obj.buyPricePaper}
                              </p>
                            </div>
                          )}
                        </Fragment>
                      )}
                      {(obj.sellType === 'bid' || obj.sellType === 'ranked_bid') && (
                        <div className="align-center">
                          <div className="icon-16">
                            <img src={PaperOutline} alt="Paper Outline" className="card-frame img-fluid" />
                          </div>
                          <p className={`card-text`}>{obj.isActive ? `PLACE BID NOW` : `BIDDING CLOSED`}</p>
                        </div>
                      )}
                    </div>
                    <button
                      onClick={() => navigate(`${RoutesList.ITEM_DETAIL_PAGE}?id=${obj.id}`)}
                      className="card-button"
                    >
                      {obj.sellType === 'bid' || obj.sellType === 'ranked_bid'
                        ? `AUCTION`
                        : obj.sellType === 'raffle'
                        ? `RAFFLE`
                        : obj.soldQuantity >= obj.quantity
                        ? `SOLD OUT`
                        : `BUY NOW`}
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-data">
                <p>No listings found</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default CardLists;
